


















import { PageModeMixin } from '@/main/mixins/pageMode';
import { showAlert } from '@/main/utils/notifications';

import { SmsEdit, SmsRequestData } from './state';
import { apiProvider } from './api';

export default PageModeMixin.extend({
	name: 'VerifySmsModal',
	props: {
		visible: { type: Boolean, required: true },
		communicationEventId: { type: Number },
	},
	data() {
		return {
			smsState: new SmsEdit(),
			loading: false,
			error: false,
		};
	},
	computed: {
		visibleCmp: {
			get() {
				return this.visible;
			},
			set(val) {
				this.$emit('update:visible', val);
			},
		},
		modalLabel(): string {
			return this.LocalizePopisPoli('VERIFY_SMS');
		},
		disableOk(): boolean {
			return this.error;
		},
		validationRules(): { smsState: Record<string, any> } {
			return {
				smsState: this.smsState.ValidationRules!,
			};
		},
		validator(): Function {
			return (this.$children[0].$refs.modalForm as any).validate;
		},
	},
	methods: {
		closeModal() {
			this.visibleCmp = false;
		},
		async sendSMS() {
			const isValid = await this.validate();
			if (!isValid) {
				return;
			}
			const requestData: SmsRequestData = {
				communicationEventId: this.communicationEventId,
				MobileNo: this.smsState.MobileNo,
			};
			this.loading = true;
			const { data: result } = await apiProvider.sendSms(requestData);
			this.visibleCmp = false;
			if (!result) {
				const message = this.LocalizeChyboveHlasky('DMS_SMSFAILURE');
				this.showErrorNotification(message);
				return;
			}
			showAlert({
				message: this.LocalizeChyboveHlasky('DMS_SMSSUCESS'),
				title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
				options: {
					type: 'info',
				},
			});
		},
		async validate() {
			let isValid;
			this.validator((valid: boolean) => {
				isValid = valid;

				valid || this.showErrorAlert({ message: 'InvalidForm' });
			});
			return isValid;
		},
		beforeRemove(file: { Mandatory: boolean }) {
			return !file.Mandatory;
		},
	},
	watch: {
		visible(visibleValue: boolean) {
			this.smsState = new SmsEdit();
			this.error = false;
			this.loading = false;
		},
	},
});
